import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/imgs/logo.webp'
import _imports_1 from '@/assets/imgs/logo.png'
import _imports_2 from '@/assets/imgs/server.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-cf6f8ce4")

_pushScopeId("data-v-cf6f8ce4")
const _hoisted_1 = _imports_0
const _hoisted_2 = { class: "select-service-root" }
const _hoisted_3 = {
  action: "",
  class: "form"
}
const _hoisted_4 = /*#__PURE__*/_createVNode("picture", { class: "logo" }, [
  /*#__PURE__*/_createVNode("source", {
    type: "image/webp",
    srcset: _hoisted_1
  }),
  /*#__PURE__*/_createVNode("img", {
    src: _imports_1,
    "data-was-processed": "true",
    "data-src": "~@/assets/imgs/logo.png"
  })
], -1)
const _hoisted_5 = { class: "form-title" }
const _hoisted_6 = { class: "p1" }
const _hoisted_7 = /*#__PURE__*/_createVNode("span", { class: "icon-check" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("span", { class: "icon-x" }, null, -1)
const _hoisted_9 = { class: "p2" }
const _hoisted_10 = { class: "form-group" }
const _hoisted_11 = { class: "btn-group" }
const _hoisted_12 = { class: "btn-label" }
const _hoisted_13 = { class: "btn-label" }
const _hoisted_14 = { class: "btn-label" }
const _hoisted_15 = { class: "input-group" }
const _hoisted_16 = { class: "btn-label" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_language_box = _resolveComponent("language-box")

  return (_openBlock(), _createBlock("div", _hoisted_2, [
    _createVNode("div", {
      class: ["lang", _ctx.lang],
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showLangbox = true))
    }, _toDisplayString(_ctx.iN(`lang.${_ctx.lang}`)), 3),
    _createVNode("form", _hoisted_3, [
      _hoisted_4,
      _createVNode("h3", _hoisted_5, _toDisplayString(_ctx.iN('serverselection.lineSelection')), 1),
      _createVNode("p", _hoisted_6, [
        _createTextVNode(_toDisplayString(_ctx.iN('serverselection.p1')) + " ", 1),
        _hoisted_7,
        _createTextVNode(" " + _toDisplayString(_ctx.iN('serverselection.p2')) + " ", 1),
        _hoisted_8,
        _createTextVNode(" " + _toDisplayString(_ctx.iN('serverselection.p3')), 1)
      ]),
      _createVNode("p", _hoisted_9, _toDisplayString(_ctx.iN('serverselection.p4')), 1),
      _createVNode("div", _hoisted_10, [
        _createVNode("div", _hoisted_11, [
          _createVNode("div", {
            class: ["btn", { disabled: !_ctx.line1 }],
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.clickLine(1)))
          }, [
            _createVNode("div", _hoisted_12, _toDisplayString(_ctx.iN('serverselection.line1')), 1),
            _createVNode("div", {
              class: ["btn-icon", _ctx.line1 ? 'icon-check' : 'icon-x']
            }, null, 2)
          ], 2),
          _createVNode("div", {
            class: ["btn", { disabled: !_ctx.line2 }],
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.clickLine(2)))
          }, [
            _createVNode("div", _hoisted_13, _toDisplayString(_ctx.iN('serverselection.line2')), 1),
            _createVNode("div", {
              class: ["btn-icon", _ctx.line2 ? 'icon-check' : 'icon-x']
            }, null, 2)
          ], 2),
          _createVNode("div", {
            class: ["btn", { disabled: !_ctx.line3 }],
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.clickLine(3)))
          }, [
            _createVNode("div", _hoisted_14, _toDisplayString(_ctx.iN('serverselection.line3')), 1),
            _createVNode("div", {
              class: ["btn-icon", _ctx.line3 ? 'icon-check' : 'icon-x']
            }, null, 2)
          ], 2)
        ]),
        _createVNode("div", _hoisted_15, [
          _withDirectives(_createVNode("input", {
            type: "text",
            placeholder: _ctx.iN('serverselection.customline'),
            class: "input",
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.serverStr = $event))
          }, null, 8, ["placeholder"]), [
            [
              _vModelText,
              _ctx.serverStr,
              void 0,
              { trim: true }
            ]
          ]),
          _createVNode("div", {
            class: ["btn", { disabled: _ctx.serverStr.length <= 0 }],
            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.enterLogin && _ctx.enterLogin(...args)))
          }, [
            _createVNode("div", _hoisted_16, _toDisplayString(_ctx.iN('serverselection.enter')), 1)
          ], 2)
        ])
      ]),
      _createVNode("img", {
        src: _imports_2,
        class: "server",
        onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.OnCLickedServer && _ctx.OnCLickedServer(...args)))
      })
    ]),
    _createVNode(_Transition, { name: "fadein-out" }, {
      default: _withId(() => [
        (_ctx.showLangbox)
          ? (_openBlock(), _createBlock(_component_language_box, {
              key: 0,
              class: "lang-box",
              onOnClose: _cache[8] || (_cache[8] = ($event: any) => (_ctx.showLangbox = false))
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode("div", {
      class: "cs-service icon-costumer-service",
      title: "线上客服",
      onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.OnCLickedServer && _ctx.OnCLickedServer(...args)))
    })
  ]))
})